import React from 'react';
// logic
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { useDispatch } from 'react-redux';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import ToolbarTitle from '../../ui/toolbar/toolbar-title';
import ToolbarContainer from '../../ui/containers/toolbar-container';
import ToolbarButton from '../../ui/toolbar/toolbar-button';
// components

const NewTicketToolbar = ({ className }) => {
  const dispatch = useDispatch();

  return (
    <ToolbarContainer>
      <ToolbarTitle>New ticket</ToolbarTitle>
      <ToolbarButton
        onClick={() => {
          dispatch(push(`${routes.emergencies}/`));
        }}
      >
        <CloseIcon />
      </ToolbarButton>
    </ToolbarContainer>
  );
};

export default NewTicketToolbar;
